import { trackClick as trackClickHandler } from '@bumble/seo-events-tracking';
import { IncomingMessage } from 'http';
import { sendData } from 'lib/api/send-data';

export type TrackClickProps = {
  req: IncomingMessage;
  lang: string;
};

export const trackClick = ({ req, lang }: TrackClickProps) =>
  trackClickHandler({
    headers: req.headers,
    lang,
    eventName: 'SEO_CLICK',
    /**
     * as req.url already has / - we can send emty route
     */
    eventRoute: req.url || '/features/unknown',
    eventDomain: 'bumble.com',
    sendEventHandler: sendData,
  });
